import { useQuery } from "@tanstack/react-query";
import { getActiveCalls, getAllCall, getUserCallsById } from "../../api/calls/callsApi";


export const useGetAllCalls = (params?: {
  name: string | undefined;
  page?: number;
  limit?: number;
}) => {
    return useQuery({
        queryKey: ["all-calls", params],
        queryFn: async () => {
            const response = await getAllCall(params);
            return response;
        },
    });
};

export const useGetActiveCalls = () => {
    return useQuery({
        queryKey: ["active-calls"],
        queryFn: async () => {
            const response = await getActiveCalls();
            return response;
        },
        refetchInterval: 5000, // Refetch every 5 seconds
        refetchIntervalInBackground: true,
        staleTime: 1000 * 30, // 30 seconds
    });
};

export const useGetUserCallsById = (userId?: string | number) => {
    const enabled =
        (typeof userId === 'number' && Number.isFinite(userId)) ||
        (typeof userId === 'string' &&
            userId.trim().length > 0 &&
            userId !== 'undefined' &&
            userId !== 'null');

    return useQuery({
        queryKey: ["user-calls", userId],
        queryFn: async () => {
			if (!enabled) return;
            const response = await getUserCallsById(userId);
            return response;
        },
		enabled,
    });
};
